import PropTypes from 'prop-types';

import { Container } from '../Containers';

import './styles/verticalEmptyStateStyles.css';

const VerticalEmptyStateTemplate = ({ children, ...rest }) => (
  <div className="flex justify-center">
    <Container type="max-3XL">
      <div
        className="flex flex-col items-center vertical-empty-state"
        {...rest}
      >
        {children}
      </div>
    </Container>
  </div>
);

VerticalEmptyStateTemplate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default VerticalEmptyStateTemplate;
